import React, { useEffect, useState } from 'react'
import { API_URL } from '../../env'
import '../../styles/Diagnostic/DiagnosticPDF.css'
import { Fade } from 'react-awesome-reveal'
import { Col, Row } from 'react-bootstrap'
import logo from '../../assets/logo.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import Button from '../Utils/Button'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'
import { ThreeCircles } from 'react-loader-spinner'

function DiagnosticPDF() {

    const { diagnosticToken } = useParams()
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingPDF, setIsLoadingPDF] = useState(true)

    useEffect(() => {

        downloadPDF()

    }, [])

    function downloadPDF() {

        axios.get(API_URL + 'diagnostic/PDFVerification/' + diagnosticToken, {
            params: {
                tokenPDF: diagnosticToken,
            }
        }).then((response) => {
            if (response.data === 'DIAGNOSTIC_PDF_VERIFIED') {
                window.location.href = API_URL + 'diagnostic/PDFDownload/' + diagnosticToken
            }
            setIsLoading(false)
            setIsLoadingPDF(false)
        }).catch((error) => {
            if (error.response) {
                var errorMessage = error.response.data.message
                if (errorMessage === "ERROR_DIAGNOSTIC_NOT_FOUND") {
                    errorMessage = "Le diagnosticest introuvable"
                } else if (errorMessage === "ERROR_DIAGNOSTIC_EXPIRED") {
                    errorMessage = "Le lien du diagnostic a expiré"
                } else if (errorMessage === "ERROR_DIAGNOSTIC_PDF_NOT_FOUND") {
                    errorMessage = "Le fichier PDF du diagnostic est introuvable"
                } else if (errorMessage === "FORBIDDEN") {
                    errorMessage = "Le lien est incorrect"
                }
            }
            toast.error(errorMessage)
            setIsLoadingPDF(false)
        })

    }

    if (isLoading) {
        return (

            <>
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                    <meta name="title" content="Télécharger votre diagnostic - E5M Diagnostics" />
                    <meta name="description" content="Télécharger votre diagnostic de E5M Diagnostics." />
                </Helmet>

                {isLoadingPDF ?
                    <ThreeCircles visible={true} height={"100"} width={"100"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} wrapperClass={"loader"} />
                    : null
                }
            </>

        )
    } else {
        return (

            <>
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                    <meta name="title" content="Télécharger votre diagnostic - E5M Diagnostics" />
                    <meta name="description" content="Télécharger votre diagnostic de E5M Diagnostics." />
                </Helmet>

                <BrowserView>
                    <div id='diagnosticPDF'>
                        <Row>
                            <Col sm={8}>
                                <Fade direction={'down'}>
                                    <div id='diagnosticPDFLeft'>
                                        <h1 id='diagnosticPDFLeftTitle'>
                                            <FontAwesomeIcon icon={faFilePdf} className='diagnosticPDFLeftIcon' />
                                            Télécharger votre diagnostic
                                            <FontAwesomeIcon icon={faFilePdf} className='diagnosticPDFLeftIcon' />
                                        </h1>
                                        <img src={logo} id='diagnosticPDFLeftLogo' alt='logo' />
                                    </div>
                                </Fade>
                            </Col>
                            <Col sm={4}>
                                <Fade direction={'up'}>
                                    <div id='diagnosticPDFRight'>
                                        <div id='diagnosticPDFRightTitle'>Si le téléchargement n'a pas démarré automatiquement, veuillez cliquer sur le bouton ci-dessous</div>
                                        <Button
                                            theme={'dark'}
                                            icon={<FontAwesomeIcon icon={faDownload} />}
                                            text={'Télécharger'}
                                            rounded={true}
                                            onClick={() => downloadPDF()}
                                        />
                                        <div id='diagnosticPDFRightTitle'>Une copie du diagnostic vous a aussi été envoyé par email</div>
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                    </div>
                </BrowserView>

                <MobileView>
                    <div id='diagnosticPDF'>
                        <Row>
                            <Col sm={8}>
                                <Fade direction={'down'}>
                                    <div id='diagnosticPDFLeftMobile'>
                                        <h1 id='diagnosticPDFLeftTitleMobile'>
                                            <FontAwesomeIcon icon={faFilePdf} className='diagnosticPDFLeftIconMobile' />
                                            Télécharger votre diagnostic
                                            <FontAwesomeIcon icon={faFilePdf} className='diagnosticPDFLeftIconMobile' />
                                        </h1>
                                        <img src={logo} id='diagnosticPDFLeftLogoMobile' alt='logo' />
                                    </div>
                                </Fade>
                            </Col>
                            <Col sm={4}>
                                <Fade direction={'up'}>
                                    <div id='diagnosticPDFRightMobile'>
                                        <div id='diagnosticPDFRightTitleMobile'>Si le téléchargement n'a pas démarré automatiquement, veuillez cliquer sur le bouton ci-dessous</div>
                                        <Button
                                            theme={'dark'}
                                            icon={<FontAwesomeIcon icon={faDownload} />}
                                            text={'Télécharger'}
                                            rounded={true}
                                            onClick={() => downloadPDF()}
                                        />
                                        <div id='diagnosticPDFRightTitleMobile'>Une copie du diagnostic vous a aussi été envoyé par email</div>
                                    </div>
                                </Fade>
                            </Col>
                        </Row>
                    </div>
                </MobileView>
            </>

        )

    }

}

export default DiagnosticPDF